import TwoFactorAuthDialog from 'componets/two-factor-auth-dialog';
import {
  use2FaContext,
  TOGGLE_2FA_DIALOG,
  TOGGLE_DISABLE_2FA_DIALOG,
} from 'features/profile/profile-account-setting-section/use-2fa';
import React, { useCallback, useEffect } from 'react';
import { Disable2FaDialog } from 'componets/two-factor-auth-dialog/two-factor-auth-dialog';
import { useAppContext } from 'use-app';
import { CheckCircleFillIcon } from 'icons';
import analytics from 'service/analytics';
import { ProfileAccountSettingListItem } from './profile-account-setting-list-item';

const Profile2Fa = React.forwardRef((_, ref) => {
  const Profile2FaCard = () => {
    const { state: globalState, fetchUserInfo } = useAppContext();
    const { me } = globalState;
    const { state, dispatch } = use2FaContext();
    const isEnabled = me.enabled2Fa;

    const toggle2FaDialog = useCallback(() => {
      dispatch({
        type: TOGGLE_2FA_DIALOG,
      });
    }, [dispatch]);

    const toggleDisable2FaDialog = useCallback(() => {
      dispatch({
        type: TOGGLE_DISABLE_2FA_DIALOG,
      });
    }, [dispatch]);

    useEffect(() => {
      if (state.needUpdateUserInfo) {
        fetchUserInfo();
      }
    }, [state.needUpdateUserInfo, fetchUserInfo]);

    return (
      <ProfileAccountSettingListItem
        label="兩步驟驗證"
        value={
          isEnabled ? (
            <>
              <CheckCircleFillIcon color="#00D7B2" width={20} height={20} style={{ marginRight: '2px' }} />
              已開啟
            </>
          ) : (
            '未開啟'
          )
        }
        button={{
          onClick: () => {
            if (isEnabled) {
              analytics.track('帳號資訊頁_帳號_兩步驟驗證_關閉設定_click');
              toggleDisable2FaDialog();
            } else {
              analytics.track('帳號資訊頁_帳號_兩步驟驗證_設定_click');
              toggle2FaDialog();
            }
          },
          content: isEnabled ? '關閉設定' : '設定',
        }}
      />
    );
  };

  return (
    <use2FaContext.Provider>
      <Profile2FaCard />
      <TwoFactorAuthDialog />
      <Disable2FaDialog />
    </use2FaContext.Provider>
  );
});

export default Profile2Fa;
